import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"

export type SmsUsageGrouping = "day" | "type" | "company" | "number"

export interface SmsUsageFigures {
  accepted: number
  delivered: number
  undelivered: number
  failed: number
  skipped: number
  cost: string
  slowest_seconds: number
  d23: {
    timed: number
    within_target_share: string | null
    target_missed: boolean
  }
}

export interface SmsUsageRow extends SmsUsageFigures {
  key: {
    day?: string
    notification_type?: number | null
    label?: string | null
    team_id?: string | null
    team__name?: string | null
    from_number?: string
  }
}

export interface SmsUsageReport {
  period: { start: string; end: string }
  group_by: SmsUsageGrouping
  totals: SmsUsageFigures
  rows: SmsUsageRow[]
  opt_outs: { stopped: number; started: number }
  queue?: { waiting: number; clears_at: string | null }
}

export const getSmsUsage = (params: {
  start: string
  end: string
  group_by: SmsUsageGrouping
}): Promise<ApiResponse<SmsUsageReport>> =>
  request.api.get("/notifications/sms/usage/", params)
